namespace gotoAndPlay {

    interface IHeaderSettings {
        hasSubnavSelector?: string;
        openClass?: string;
        activeClass?: string;
        navItemClass?: string;
        navLinkClass?: string;
        mainNavClass?: string;
        toggleClass?: string;
        mobileOpen?: string;
        noticeCloseClass?: string;
    }

    /**
     * @brief      Header class
     */
    class Header {
        element: JQuery;
        settings: IHeaderSettings;
        megaMenuContainer: JQuery;
        hasSubnav: JQuery;
        animating: boolean;
        megaMenuOpen: boolean;
        submegaMenuOpen: boolean;
        mainNav: JQuery;
        mobileToggle: JQuery;
        overlay: JQuery;
        navLink: JQuery;
        noticeClose: JQuery;

        constructor(target: JQuery) {
            this.settings = {
                navItemClass: 'navigation__item',
                navLinkClass: '.navigation__megamenu .navigation__link',
                hasSubnavSelector: '.has-children',
                openClass: 'is-megamenu-open',
                activeClass: 'is-active',
                mainNavClass: '.header__navigation',
                toggleClass: '.header__toggle',
                mobileOpen: 'is-mobile-open',
                noticeCloseClass: '.header__notice-button',
            };

            this.element = target;
            this.megaMenuContainer = $('body');
            this.hasSubnav = $(this.settings.hasSubnavSelector);
            this.mainNav = $(this.settings.mainNavClass);
            this.mobileToggle = $(this.settings.toggleClass);
            this.overlay = $('.' + this.settings.openClass);
            this.navLink = $(this.settings.navLinkClass);
            this.noticeClose = $(this.settings.noticeCloseClass);
            this.animating = false;
            this.megaMenuOpen = false;
            this.submegaMenuOpen = false;

            this.init();
        }

        init(): void {
            this.hasSubnav.on('click', this.openMegamenu.bind(this));
            this.mobileToggle.on('click', this.openMobileMenu.bind(this));
            this.navLink.on('click', this.ignoreMegamenuClose.bind(this));
            this.noticeClose.on('click', this.closeNotice.bind(this));
        }

        initNotice(): void {
            if (!Cookie.get('cookie-agreement')) {
                setTimeout(() => {
                    $('.header').addClass('has-visible-notice');
                }, 300);
            }
        }

        closeNotice(event: JQuery.Event): void {
            // Close notification
            $('.header').removeClass('has-visible-notice');

            // Add cookie to hide it next time
            Cookie.set('cookie-agreement', 'yes', 8760);
        }

        ignoreMegamenuClose(): void {
            event.stopPropagation();
        }

        openMobileMenu(): void {
            if (this.megaMenuOpen) {
                this.megaMenuContainer.removeClass(this.settings.mobileOpen);

                setTimeout(function() {
                    Helpers.enableScroll();
                }, 400);

                this.megaMenuOpen = false;
            } else {
                this.megaMenuOpen = true;

                Helpers.disableScroll();
                this.megaMenuContainer.addClass(this.settings.mobileOpen);
            }
        }

        openMegamenu(event): void {
            event.stopPropagation();
            event.preventDefault();
            let self = $(event.target).closest('.' + this.settings.navItemClass);

            if (!this.megaMenuOpen) {
                this.megaMenuOpen = true;
                this.megaMenuContainer.addClass(this.settings.openClass);
                self.addClass(this.settings.activeClass);
            } else {
                let currActive = this.mainNav.find('.' + this.settings.activeClass);
                if (self.is(currActive)) {
                    this.closeMegamenu(event);
                } else {
                    if (self.hasClass('has-children')) {
                        currActive.removeClass(this.settings.activeClass);
                        self.addClass(this.settings.activeClass);
                    } else {
                        this.closeMegamenu(event);
                    }
                }
            }
        }

        closeMegamenu(event: any = null): void {
            event.stopPropagation();
            event.preventDefault();

            let self = this.mainNav.find('.' + this.settings.activeClass);

            this.megaMenuContainer.removeClass(this.settings.openClass);
            self.removeClass(this.settings.activeClass);
            this.megaMenuOpen = false;
        }
    }

    // Init on document ready
    export let header;
    $(function() {
        header = new Header($('.header'));
    });
}
